import { render, staticRenderFns } from "./Digital-assets.vue?vue&type=template&id=9e81b964&scoped=true&"
import script from "./Digital-assets.vue?vue&type=script&lang=js&"
export * from "./Digital-assets.vue?vue&type=script&lang=js&"
import style0 from "./Digital-assets.vue?vue&type=style&index=0&id=9e81b964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e81b964",
  null
  
)

export default component.exports